module.exports = __webpack_public_path__ + "static/Download_on_the_App_Store_Badge_ES_RGB_blk_100217-ebdcadff6fb5dd15a86387038f2d7820.svg";